import { render, staticRenderFns } from "./Ordered.vue?vue&type=template&id=ffa2a76e&scoped=true&"
import script from "./Ordered.vue?vue&type=script&lang=js&"
export * from "./Ordered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa2a76e",
  null
  
)

export default component.exports